import { render } from "./ShopGame.vue?vue&type=template&id=5e4d5c0c"
import script from "./ShopGame.vue?vue&type=script&lang=ts"
export * from "./ShopGame.vue?vue&type=script&lang=ts"
script.render = render

export default script